module.exports = __webpack_public_path__ + "img/Frame (1).284f5ca8.png";